export default "__VITE_ASSET__QtsltD8k__"